module.exports = __webpack_public_path__ + "media/images/pic/brodno/people/kasia-5edaddfb5d9f7387a25c9d10602652b1.png";